import styles from "./style.module.scss";
import SaunaImage01 from "src/assets/activity/sauna/01.jpg";
import SaunaImage02 from "src/assets/activity/sauna/02.jpg";
import SaunaImage03 from "src/assets/activity/sauna/03.jpg";
import SaunaImage04 from "src/assets/activity/sauna/04.jpg";
import SaunaImage05 from "src/assets/activity/sauna/05.jpg";
import SaunaImage06 from "src/assets/activity/sauna/06.jpg";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const IMAGES = [
  SaunaImage01,
  SaunaImage02,
  SaunaImage03,
  SaunaImage04,
  SaunaImage05,
  SaunaImage06,
];

export const SaunaSection = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <p id="sauna" className={styles.sectionTitle}>
          自然の循環を感じ、森に溶け込む極上サウナ
        </p>

        <Slider {...settings}>
          {IMAGES.map((src, i) => (
            <img src={src} alt={`slide-${i}`} key={i} />
          ))}
        </Slider>

        <p className={styles.description}>
          60年越しに橋がかかった女川町・出島（いずしま）で、森に”根（JUURI）”を張り、海と生きる循環を生む極上サウナを楽しむことができます。島の間伐材を使用したログサウナやフィンランドの伝統的な蓄熱式ストーブを使ったサウナを楽しむことが、出島の森と海にも良い影響が生まれます。
        </p>
        <h3>information -詳細情報-</h3>

        <ul>
          <li>
            <p className={styles.head}>体験場所</p>
            <p className={styles.body}>
              <span style={{ textAlign: "center" }}>
                JUURI SAUNA
                <br />
                （〒986-2211　宮城県牡鹿郡女川町出島字別当浜2-33）
              </span>
            </p>
          </li>
          <li>
            <p className={styles.head}>体験人数</p>
            <p className={styles.body}>1〜4名</p>
          </li>
          <li>
            <p className={styles.head}>体験可能時間</p>
            <p className={styles.body}>11:00〜14:00、16:00〜19:00</p>
          </li>
          <li>
            <p className={styles.head}>所要時間</p>
            <p className={styles.body}>3時間</p>
          </li>
          <li>
            <p className={styles.head}>料金</p>
            <p className={styles.body}>1〜4名 計28,000円</p>
          </li>
          <li>
            <p className={styles.head}>予約方法</p>
            <p className={styles.body}>
              <Link to="/reservation">ご予約ページ</Link>で選択ください
            </p>
          </li>
        </ul>
        <p className={styles.ulInfo}>
          ※料金は時期などによって変動する可能性があるため、詳しくは店舗にご確認ください。
        </p>
      </div>
    </section>
  );
};
